import { IMapMarker, LatLng } from "../map-provider.interface";

export class GoogleMarker implements IMapMarker {
    private readonly _marker: google.maps.marker.AdvancedMarkerElement;

    constructor(marker: google.maps.marker.AdvancedMarkerElement) {
        this._marker = marker;
    }

    remove(): void {
        this._marker.map = null;
    }

    onClick(handler: () => void): void {
        this._marker.addListener("gmp-click", handler);
    }

    getPosition(): LatLng {
        const p = this._marker.position as google.maps.LatLngLiteral;
        return { lat: p.lat, lng: p.lng };
    }

    /** internal escape hatch for clustering, info windows, etc */
    _native(): google.maps.marker.AdvancedMarkerElement {
        return this._marker;
    }
}